import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfNumeracionDian } from '@/modules/Financiera/interfaces/INumeracionDian'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
export class NumeracionDianService extends BaseService<IConfNumeracionDian> {
  constructor() {
    super({
      baseUrl: 'financiera/numeracion-dian/'
    })
  }
  async getValid(condTipoDocumento: 'FACTURA' | 'NOTA_CREDITO' = 'FACTURA'): Promise<AxiosResponse<IResponseApi<IConfNumeracionDian[]>>> {
    return this.http.get<IResponseApi<IConfNumeracionDian[]>>('/valid', { params: { condTipoDocumento } })
  }
}
